import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { ClaimedManufacturingOrder } from '../claimed-manufacturing-order';
import { ManufacturingOrderBuilder } from './manufacturing-order.builder';
import { UserBuilder } from './user.builder';

export class ClaimedManufacturingOrderBuilder {

  static fromJson(json) {
    return (json)
      ? new ClaimedManufacturingOrder(
        json.hash,
        parseNumber(json.date),
        ManufacturingOrderBuilder.fromJson(json.manufacturingOrder),
        UserBuilder.fromJson(json.user)
      ) : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ClaimedManufacturingOrderBuilder.fromJson) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/claimed-manufacturing-order.builder.ts